import { SectionLabelCombinedProps } from './types';

const usePresenter = (props: SectionLabelCombinedProps): SectionLabelCombinedProps => {
  return props;
};

export default usePresenter;
